export enum ConfirmationDialogMessages {
  DEFAULT_MESSAGE = 'Are you sure?',
  DEFAULT_TITLE = 'Confirmation',

  BUTTON_CONFIRM = 'Confirm',
  BUTTON_CANCEL = 'Cancel',
}
